(() => {
  const init = () => {
    const catalog = document.querySelector('[data-v3-catalog]');
    if (!catalog || catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    const params = new URLSearchParams(location.search);
    const query = (params.get('q') || '').trim().slice(0, 160);
    const cards = [...catalog.querySelectorAll('[data-product-search]')];
    const input = document.querySelector('.header-search input[name="q"]');
    if (input) input.value = query;
    const normalize = value => value.normalize('NFKC').toLocaleLowerCase().replace(/[\s\-‐‑–—]/g, '');
    if (query) {
      const words = query.split(/\s+/).filter(Boolean).map(normalize);
      let count = 0;
      cards.forEach(card => {
        const matches = words.every(word => normalize(card.dataset.productSearch).includes(word));
        card.hidden = !matches;
        if (matches) count++;
      });
      const summary = catalog.querySelector('[data-search-summary]');
      summary.hidden = false;
      summary.querySelector('[data-search-text]').textContent = catalog.dataset.resultTemplate.replaceAll('{query}', query).replaceAll('{count}', String(count)) + (count ? '' : ' ' + catalog.dataset.noResults);
      catalog.querySelectorAll('[data-upcoming-category]').forEach(section => { section.hidden = true; });
    }
    const update = () => {
      const hash = location.hash.slice(1);
      const target = document.getElementById(hash);
      const section = target?.closest('[data-category]');
      catalog.querySelectorAll('.v3-category-tabs a').forEach(link => {
        if (link.hash === `#${section?.id || 'smart-security'}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      // A direct model link always reveals its target even if an old search query remains.
      if (target?.matches('[data-product-search]') && target.hidden) {
        const destination = new URL(location.href);
        destination.searchParams.delete('q');
        location.replace(destination.href);
      }
    };
    update();
    window.addEventListener('hashchange', update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
